import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EChartOption } from 'echarts';

@Component({
  selector: 'app-grafup',
  templateUrl: './grafup.component.html',
  styleUrls: ['./grafup.component.css']
})
export class GrafupComponent implements OnInit {
  theme:string="";
  inter:any;
  @Input() titulo:string;
  @Input() grafo:any;
  @Input() grafoptions:EChartOption;
  @Input() loadingOption:any;
  @Input() updateOption:any;
  tooltip:any;
  isLoading:boolean=true;
 
  constructor(public dialogRef: MatDialogRef<GrafupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if(this.data){
      console.log(this.data)
      this.titulo = this.data.titulo;
      this.tooltip = this.data.tooltip;
      this.grafoptions = this.data.grafoptions;
      this.loadingOption = this.data.loadingOption;
      setTimeout(() => {
        this.updateOption  = this.data.updateOption;
          this.isLoading = false;
      }, 1000);
    }
  }

  onChartInit(ev){
    console.log("onChartInit")
    this.grafo = ev;
    this.grafo.showLoading();
  }

  onChartEvent(ev, id){
    console.log(ev);
  }

}